<template>
  <div class="row">
    <div class="col-12">
      <order-details is-enrolled />
    </div>
  </div>
</template>
<script>
import OrderDetails from '../common/OrderDetails'
export default {
  name: 'EnterpriseOrderDetails',
  components: {
    OrderDetails
  },
  created () {

  }
}
</script>
